define( 'templates/device-message-error-templates',['templates/template-builder'], function(TemplateBuilder) {
    var templateBuilder = new TemplateBuilder();
    
    return {
        /**
         * HEADERS -------------------------------------------------------
         */
        'headers' : {
            // Sortable
            'did' : templateBuilder.sortableHeader('did', 'Device ID', 'did'),
            'time' : templateBuilder.sortableHeader('time', 'Date', 'time'),
            
            // Basic 
            'raw' : templateBuilder.basicHeader('raw', 'Raw'),
            'info' : templateBuilder.basicHeader('info', 'Information'),
            'status' : templateBuilder.basicHeader('status', 'Status')
        },
        
        /**
         * DATA TEMPLATES -------------------------------------------------------
         */
        'templates' : {
            'did' : templateBuilder.linkNode( '${deviceUrl}', '${device}' ),
            'time' : templateBuilder.basicNode( '${date}' ),
            'raw' : templateBuilder.basicNode( '${data}' ),
            'info' : templateBuilder.basicNode( '${message}' ),
            'status' : templateBuilder.basicNode( '${status}' )
        } // end templates data
    }; // end return
});

